import React, { Component, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import isEqual from 'lodash/isEqual';
import { initViewport } from '../../redux/viewportActions';
import { initNetwork } from '../../redux/networkActions';
import { fetchMeWorkflow, logoutWorkflow, openAuthModal, fetchNotificationsWorkflow, fetchPlatformNotificationsWorkflow, changeUserFeedbackModalStatusWorkflow, postUserProfileDataWorkflow, autoCompleteUserDataWorkflow, openUserProfileModal, closeUserProfileModal, openDonateModal, closeDonateModal, fetchAutoSuggestionsWorkflow, updateWordSearchFrequencyWorkFlow, addNewSearchWordWorkFlow, markAllNotificationsAsReadWorkflow, markOneNotificationsAsReadWorkflow, changeLanguage, updateConsentWorkflow, updateDonatePopupStatusWorkFlow, updateActiveDropdownLink, updateActiveMenuSelected, bottomMenuSelected } from '../../redux/userActions'
import { submitStoryNotice, fetchBannerImagesWorkflow , fetchEngagementWorkFlow, fetchTrendingThemesWorkflow, fetchSeoDataWorkflow} from '../../redux/homeActions'
import { subscribeWorkflow } from '../../redux/newsletterActions';
import { I18n } from 'react-polyglot';
import locales from '../../i18n';
import {
  fetchNextReadBooksWorkflow,
  fetchNextTranslationBooksWorkflow,
  fetchBookAssetsWorkflow,
  openGlobalBookReader,
  closeGlobalBookReader,
  closeGlobalQuickView,
  openNextReadSuggestions,
  closeNextReadSuggestions,
  postFlagBookWorkflow,
  postSmileyRatingWorkflow,
  postSuggestionWorkflow,
  fetchSuggestionsWorkflow,
  resetSuggestions,
  updatePageContent,
  userBlockedById,
  updateReviewerSuggestions,
  postTranslationEditorFeedbackWorkflow,
  fetchBookWorkflow,
  postGatingFormDataWorkflow,
  fetchSmileyRatingBookWorkflow, postEditBookWorkflow , postImageGatingFormDataWorkflow , blockUserWorkflow , blockStoryWorkflow ,  resolveSuggestionsWorkflow,
  postOfflineTranslateDataWorkflow,
  closeOfflineTranslator,
  openOfflineTranslator,
  fetchAssetsForOfflineTranslateWorkflow,
  postOfflineTranslationFeedbackWorkflow ,
  fetchExtendedBookWorkflow,
} from '../../redux/bookActions';
import { closeNextTranslationSuggestions} from '../../redux/nextTranslationActions';
import { addSlimNotification } from '../../redux/slimNotificationActions';
import { addSmileyRatingModal, removeSmileyRatingModal } from '../../redux/smileyRatingModalActions';
import { addGatingForm, removeGatingForm } from '../../redux/gatingFormActions';
import { fetchMobileTranslationsWorkflow } from '../../redux/allMobileTranslateActions';
import { changeTargetLanguage, fetchFiltersWorkflow, closeTranslationModal, fetchCheckTranslationsWorkflow} from '../../redux/translateActions';
import { closeListQuickView, campaignCheckStoryStatus, campaignSetStoryStatus } from '../../redux/readingListsActions';
import { enablePortraitViewMessage, disablePortraitViewMessage } from '../../redux/portraitViewMessageActions';
import {
  saveOfflineWorkflow,
  unsaveOfflineWorkflow,
  isAvailableOffline,
  saveOfflineTranslationsWorkflow,
  unsaveOfflineTranslationsWorkflow,
  fetchOfflineTranslationsWorkflow,
  updateOfflineTranslationsWorkflow,
  updateThemeDetails
} from '../../redux/offlineBooksActions';
import { fetchAllListsFiltersWorkflow } from '../../redux/allListsActions';
import { addNotificationModal, removeNotificationModal } from '../../redux/notificationModalActions';
import {setStoryStatusFn} from '../../redux/allFluencesActions';
import { gaEventActions, userAuthStages, rtlLanguages, pageURLString, translateAPILocaleList, emergentReaderLevel,  sectionClicked, mapUserGatewayProfileType, studentMenuWhitelist, userProfileType, gaEventLabel, siteLocale, links, appLanguages, siteLocaleLanguages } from '../../lib/constants';
import { flpSetStoryStatusFn, checkStoryStatus, enrollFlpUser, closeFlpEnrolModal, setFlpProgress } from '../../redux/flpHomeActions';
import { fetchProfileWorkflow } from '../../redux/profileActions';
import { fetchAllReadalongFiltersWorkflow } from '../../redux/allBooksActions';

import { translate } from 'react-polyglot';
import { onWindowSizeChange } from '../../redux/windowSizeActions';
import { loginPolicy, persistStore as myPersistStore} from '../../lib/policymanager/index'
import SiteHeader from '../SiteHeader';
import OfflineTranslateModal from '../OfflineTranslateModal/OfflineTranslateModal';
import ToggleSidebar from '../ToggleSidebar/ToggleSidebar';
import OfflineBookModal from '../OfflineBookModal';
import NextTranslationModal from '../NextTranslationModal';
import Helmet from 'react-helmet'
import Link from '../Link';

import rtl from '../RTLProvider/rtl';
import RenderOnViewportEntry from '../RenderOnViewportEntry';

import './AppContainer.scss';
import BackToTop from '../BackToTop/BackToTop';
import  { getStaticSubGcrData } from '../../redux/stemActions'
import { isRtlLanguage } from '../../lib/appHelpers';
import SiteFooterNotice from '../SiteFooter/SiteFooterNotice';

const SlimNotificationContainer = lazy(() => import('../SlimNotificationContainer'));
const BookReaderModal = lazy(() => import('../BookReaderModal'));
const QuickViewModal = lazy(() => import('../QuickViewModal'));
const NotificationModal = lazy(() => import('../NotificationModal'));
const AuthModalContainer = lazy(() => import('../AuthModalContainer'));
const UserFeedbackModal = lazy(() => import('../UserFeedbackModal'));
const UserProfileModal = lazy(() => import('../UserProfileModal'));
const TranslationModal = lazy(() => import('../TranslationModal'));
const NextReadModal = lazy(() => import('../NextReadModal'));
const SmileyRatingModal = lazy(() => import('../SmileyRatingModal'));
const GatingForm = lazy(() => import('../GatingForm'));
const ListQuickViewModal = lazy(() => import('../ListQuickViewModal'));
const PortraitViewMessage = lazy(() => import('../PortraitViewMessage'));
const RpOnboardingModalContainer = lazy(() => import('../RpOnboardingModalContainer'));
const SiteFooter = lazy(() => import('../SiteFooter'));
const DonateSeason = lazy(() => import('../DonateModal/DonateSeason'));


const mapStateToProps = state => {
  return {
    viewport: state.viewport,
    isLoggedIn: state.user.isLoggedIn,
    createdAt: state.user.createdAt,
    profile: state.user.profile,
    profileType: state.user.profile.profile_type ,
    ptrOrgs: state.user.profile.ptrOrgs,
    isFetchingMe: state.user.isFetchingMe,
    isAuthModalVisible: state.user.isAuthModalVisible, 
    isRpOnboardingModalVisible: state.allFluences.isRpOnboardingModalVisible, 
    isConsentGiven: state.user.isConsentGiven,
    showFlp: state.user.showFlp,
    isSubscribed: state.newsletter.isSubscribed,
    isFetchingSubscribe: state.newsletter.isFetchingSubscribe,
    online: state.network.online,
    bookAssets: state.book.assets,
    currentGlobalBookReaderSlug: state.book.currentGlobalBookReaderSlug,
    smileyRatingBook: state.book.smileyRatingBook,
    isFetchingSmileyRatingBook: state.book.isFetchingSmileyRatingBook,
    isGlobalBookReaderVisible: state.book.isGlobalBookReaderVisible,
    isGlobalNextReadSuggestionsVisible: state.book.isGlobalNextReadSuggestionsVisible,
    isUserProfileModalVisible: state.user.isUserProfileModalVisible,
    autoCompleteData: state.user.autoCompleteData,
    nextTranslationBooks: state.book.nextTranslationBooks,
    isGlobalNextTranslationSuggestionsVisible: state.nextTranslation.isGlobalNextTranslationSuggestionsVisible,
    showAudioBookReader: state.book.showAudioBookReader,
    showAttributionPage: state.book.showAttributionPage,
    isUserBlocked: state.book.isUserBlocked,
    globalBookReaderStartPage: state.book.globalBookReaderStartPage,
    isGlobalQuickViewVisible: state.book.isGlobalQuickViewVisible,
    currentGlobalQuickViewBook: state.book.currentGlobalQuickViewBook,
    isSubmittingTranslationEditorFeedback: state.book.isSubmittingTranslationEditorFeedback,
    stage: state.user.stage,
    isOfflineBookModalVisible: state.offlineBookModal.isofflineModalVisible,
    isUserFeedbackModalVisible: state.userFeedbackModal.isUserFeedbackModalVisible,
    isNotificationModalVisible: state.notificationModal.isNotificationModalVisible,
    windowDimensions: state.windowDimensions,
    isFetchingBookAssets: state.book.isFetchingAssets,
    nextReadBooks: state.book.nextReadBooks,
    readingListNextReadBooks: state.book.readingListNextReadBooks,
    currentGlobalBookReaderBook: state.book.currentGlobalBookReaderBook,
    isSmileyRatingModalVisible: state.smileyRatingModal.isSmileyRatingModalVisible,
    isGatingFormVisible: state.gatingForm.isGatingFormVisible,
    showImageGatingForm: state.gatingForm.showImageGatingForm,
    showAudioBookReaderOnBack: state.smileyRatingModal.showAudioBookReaderOnBack,
    storyfinder: state.smileyRatingModal.storyfinder,
    book: state.book.book,
    isFlaggingBook: state.book.isFlaggingBook,
    isUploadingGatingForm: state.book.isUploadingGatingForm,
    isUploadingUserProfile: state.user.isUploadingUserProfile,
    isSubmittingSmileyRating: state.book.isSubmittingSmileyRating,
    isFetchingNextReadBooks: state.book.isFetchingNextReadBooks,
    isGlobalTranslationModalVisible: state.translate.isGlobalTranslationModalVisible,
    currentGlobalTranslationModalBook: state.translate.currentGlobalTranslationModalBook,
    translateTargetLanguage: state.translate.targetLanguage,
    isFetchingTranslateFilters: state.translate.isFetchingFilters,
    translateFilters: state.translate.filters,
    availableTranslations: state.translate.availableTranslations,
    isCheckingTranslations: state.translate.isCheckingTranslations,
    openTranslateTabLink: state.translate.openTranslateTabLink,
    isFetchingNextTranslationBooks: state.book.isFetchingNextTranslationBooks,
    nextSuggestionsType: state.nextTranslation.nextSuggestionsType,
    translateToLanguage: state.nextTranslation.translateToLanguage,
    suggestions: state.book.suggestions,
    isFetchingSuggestions : state.book.isFetchingSuggestions,
    isEditingBook: state.book.isEditingBook,
    isListQuickViewVisible: state.readingLists.isListQuickViewVisible,
    currentQuickViewList: state.readingLists.currentQuickViewList,
    offlineBooks: state.offlineBooks,
    readingProgramBook: state.book.readingProgramBook,
    disableNextRead: state.book.disableNextRead,
    flpBook: state.book.flpBook,
    isSupplementary: state.book.isSupplementary,
    translatePartner: state.book.translatePartner,
    storyId: state.book.storyId,
    themeNumber: state.book.themeNumber,
    enrollmentId: state.book.enrollmentId,
    fluencyNumber: state.book.fluencyNumber,
    themeName: state.book.themeName,
    mobileTranslate: state.book.mobileTranslate,
    showPortraitMsg: state.portraitViewMessage.portraitMsg,
    fluencyLevel: state.allFluences.fluencyThemes.level,
    readStoryStatus: state.allFluences.readStoryStatus,
    readSource: state.book.readSource,
    hideHeaderFooter: state.allMobileTranslate.hideHeaderFooter,
    offlineTranslateTargetLanguage: state.translate.offlineTranslateTargetLanguage,
    translateOfflineMode: state.translate.translateOfflineMode,
    secClicked: state.translate.sectionClicked,
    offlineTranslateSourceLanguage: state.translate.offlineTranslateSourceLanguage,
    assetsForOfflineTranslate: state.book.assetsForOfflineTranslate,
    isOfflineTranslatorVisible: state.book.isOfflineTranslatorVisible,
    currentOfflineTranslatorBook: state.book.currentOfflineTranslatorBook,
    offlineTranslatorStartPage: state.book.offlineTranslatorStartPage,
    currentOfflineTranslatorSlug: state.book.currentOfflineTranslatorSlug,
    isSavingOfflineTranslations: state.offlineBooks.isSavingOfflineTranslations,
    isSubmittingOfflineTranslateData: state.book.isSubmittingOfflineTranslateData,
    offlineTranslations: state.offlineBooks.translations,
    activeDropdown: state.user.activeLink,
    menuSelected: state.user.menuSelected,
    isBottomMenuSelected: state.user.isBottomMenuSelected,
    isSubmittingOfflineTranslationFeedback: state.book.isSubmittingOfflineTranslationFeedback,
    isEmailConfirmed: state.user.profile.emailConfirmed,
    filters: state.allLists.filters,
    isDonateModalVisible: state.user.isDonateModalVisible, 
    gatingFormImageId: state.gatingForm.imageId,
    showStoryGatingForm: state.gatingForm.showStoryGatingForm,
    showStoryGatingFormPdf: state.gatingForm.showStoryGatingFormPdf,
    format:state.gatingForm.format,
    gatingFormStoryId: state.gatingForm.storyId,
    downloadLink: state.gatingForm.downloadLink,
    autoSuggestions: state.user.autoSuggestions,
    searchQuery: state.user.query,
    isFetchingAutoSuggestions: state.user.isFetchingAutoSuggestions,
    regId: state.book.regId,
    campaignType: state.book.campaignType,
    platformNotifications: state.user.platformNotifications,
    engagementData: state.home.engagementData,
    readCount: state.home.readCount,
    trendingThemes: state.home.trendingThemes,
    isFetchingHome: state.home.isFetchingHome,
    isTrendingTheme: state.home.isTrendingTheme,
    isOfflineRp: state.book.isOfflineRp,
    raFilters: state.allBooks.raFilters,
    seoData: state.home.seoData,
    localePreferences: state.user.profile.localePreferences,
    browserPreferences: state.user.profile.browserPreferences,
    resourceDetails: state.flpHome.resourceDetails,
    isFromFlp: state.user.isFromFlp,
    flpGrade: state.user.flpGrade,
    staticSubGcrData: state.stem.staticSubGcrData,
    isPTREnrolledUser: state.user.profile.isPTREnrolledUser,  
  }
}

const mapDispatchToProps = {
  onWindowSizeChange,
  initViewport,
  initNetwork,
  fetchMeWorkflow,
  submitStoryNotice,
  logoutWorkflow,
  updateConsentWorkflow,
  postEditBookWorkflow,
  blockUserWorkflow,
  blockStoryWorkflow,
  resolveSuggestionsWorkflow,
  subscribeWorkflow,
  changeLanguage,
  closeGlobalBookReader,
  closeGlobalQuickView,
  fetchBookAssetsWorkflow,
  fetchNextReadBooksWorkflow,
  fetchExtendedBookWorkflow,
  openGlobalBookReader,
  openNextReadSuggestions,
  closeNextReadSuggestions,
  closeNextTranslationSuggestions,
  fetchNextTranslationBooksWorkflow,
  changeUserFeedbackModalStatusWorkflow,
  closeUserProfileModal,
  openAuthModal,
  addSlimNotification,
  resetSuggestions,
  updatePageContent,
  userBlockedById,
  updateReviewerSuggestions,
  addSmileyRatingModal,
  addGatingForm,
  removeGatingForm,
  postFlagBookWorkflow,
  postSmileyRatingWorkflow,
  postSuggestionWorkflow,
  postGatingFormDataWorkflow,
  postUserProfileDataWorkflow,
  autoCompleteUserDataWorkflow,
  postImageGatingFormDataWorkflow,
  fetchSmileyRatingBookWorkflow,
  fetchBookWorkflow,
  removeSmileyRatingModal,
  fetchNotificationsWorkflow,
  fetchPlatformNotificationsWorkflow,
  closeTranslationModal,
  fetchFiltersWorkflow,
  changeTargetLanguage,
  fetchCheckTranslationsWorkflow,
  fetchMobileTranslationsWorkflow,
  fetchSuggestionsWorkflow,
  closeListQuickView,
  saveOfflineWorkflow,
  unsaveOfflineWorkflow,
  addNotificationModal,
  removeNotificationModal,
  postTranslationEditorFeedbackWorkflow,
  setStoryStatusFn,
  enablePortraitViewMessage,
  disablePortraitViewMessage,
  saveOfflineTranslationsWorkflow,
  unsaveOfflineTranslationsWorkflow,
  fetchOfflineTranslationsWorkflow,
  closeOfflineTranslator,
  postOfflineTranslateDataWorkflow,
  openOfflineTranslator,
  fetchAssetsForOfflineTranslateWorkflow,
  updateOfflineTranslationsWorkflow,
  updateThemeDetails,
  updateActiveDropdownLink,
  updateActiveMenuSelected,
  bottomMenuSelected,
  postOfflineTranslationFeedbackWorkflow,
  openUserProfileModal,
  fetchAllListsFiltersWorkflow,
  openDonateModal,
  closeDonateModal,
  updateDonatePopupStatusWorkFlow,
  fetchProfileWorkflow,
  fetchAutoSuggestionsWorkflow,
  updateWordSearchFrequencyWorkFlow,
  addNewSearchWordWorkFlow,
  flpSetStoryStatusFn,
  checkStoryStatus,
  enrollFlpUser,
  closeFlpEnrolModal,
  campaignCheckStoryStatus, 
  campaignSetStoryStatus,
  markAllNotificationsAsReadWorkflow,
  markOneNotificationsAsReadWorkflow,
  fetchBannerImagesWorkflow,
  setFlpProgress,
  fetchEngagementWorkFlow,
  fetchTrendingThemesWorkflow,
  fetchAllReadalongFiltersWorkflow,
  fetchSeoDataWorkflow,
  getStaticSubGcrData
};

@rtl
@translate()
@connect(mapStateToProps, mapDispatchToProps)
class AppContainer extends Component {
  static defaultProps = {
    chromeless: false
  }
  constructor(props){
    super(props);

    this.state = {
      landscapeMode: false,
      isUpdatingRPBooks: false,
      timer: null
    }
  }

  componentWillMount() {
    const {
      fetchNotificationsWorkflow,
      fetchPlatformNotificationsWorkflow,
      addSlimNotification
    } = this.props;

  
   
    window.addEventListener("storage", event => {
      if (event.key === 'user-profile-submission') {
        this.props.fetchMeWorkflow().then((response) => {
          if (response.data.showUserProfiling === false) {
            this.props.closeUserProfileModal()
            if (response.data.isLoggedIn){
              fetchPlatformNotificationsWorkflow();
            }
          }
        })
      }
    }
      , false);
    
    // Ref URL: https://stackoverflow.com/questions/42111784/how-user-will-logout-from-all-open-tabs-automatically-when-user-logs-out-in-one/42181190 
    window.addEventListener("storage", event => {
      if (event.key === 'sw-log-in-out-activity' || event.key === 'sw-offline-activity' || event.key === 'sw-bookshelf' || event.key === 'sw-bookmark' || event.key === 'sw-jotform' || event.key === 'stem-enrol' || event.key === 'flp-enrol' || event.key === 'pledge-enrol' || event.key === 'user-profile-submission') { 
        window.location.reload();
      }
    }
    , false);

    fetchNotificationsWorkflow().then((response) => {

      if(response.flashMessages) {
        const flashMessages = response.flashMessages;
        if (flashMessages['success']) {
          addSlimNotification({
            type: 'success',
            content: flashMessages['success']
          })
        }
        else if (flashMessages['error']) {
          addSlimNotification({
            type: 'danger',
            content: flashMessages['error']
          })
        }
        else if (flashMessages['alert']) {
          //TODO: This needs to be changed to warning state after warning state is added to SlimNotification
          addSlimNotification({
            type: 'danger',
            content: flashMessages['alert']
          })
        }
        else {
          addSlimNotification({
            //'Info' is the default state for any other type of flash messages ex. notice, etc
            content: flashMessages['notice']
          })
        }
      }
    });

    window.addEventListener("orientationchange", this.checkOrientation);
    this.checkOrientation();
  }


  removeParam(key, sourceURL) {
    let newUrl = sourceURL.split("?")[0];
    let queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      let paramsArr = queryString.split("&");
      for (let i = 0 ; i < paramsArr.length ; i++ ) {
        let param = paramsArr[i].split("=")[0];
        if (param === key) {
          paramsArr.splice(i, 1);
        }
      }
      newUrl = newUrl + "?" + paramsArr.join("&");
    }
    return newUrl;
  }

  componentDidMount() {
    const {
      initViewport,
      initNetwork,
      fetchMeWorkflow,
      addSlimNotification,
      submitStoryNotice,
      onWindowSizeChange,
      location,
      t,
      getStaticSubGcrData
    } = this.props;

    let languageChange = localStorage.getItem('languageChange');
    let locale = localStorage.getItem('locale');

    window.addEventListener('resize', onWindowSizeChange);

    window.addEventListener('beforeinstallprompt', () => { });

    initViewport();
    initNetwork();
    getStaticSubGcrData();
    let noFetchMePathsMatch = location.pathname.match(/\/third-party-user-login\/[A-Za-z0-9.-]+/g)
    if (noFetchMePathsMatch && noFetchMePathsMatch.length > 0)
      return;
 // we have to pass flag in me api for reading page sothat only required data is loaded 
    fetchMeWorkflow(window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === pageURLString.readingProgramme).then((response) => {
      if(response.meta && response.meta.contestStoryNotice){
        addSlimNotification({
          content: t("Contest.notification-text")
        })
        submitStoryNotice();
      }
      if (this.props.isLoggedIn && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') !== pageURLString.readingProgramme && window.location.pathname.replace(`/${siteLocale}`, '') !== "/foundational-literacy-programme/grades" && !window.location.pathname.includes("/foundational-create-classroom") && !window.location.pathname.includes("/stem-literacy-programme/trainingresources") && window.location.pathname.replace(`/${siteLocale}`, '') !== "/profile" && !window.location.pathname.includes("/foundational-literacy-programme/resource") && !window.location.pathname.includes("/foundational-literacy-programme/trainingresources") && window.location.pathname.replace(`/${siteLocale}`, '') !== "/foundational-literacy-programme") {
        if (response && response.data && response.data.showUserProfiling === true) {
        let timer = window.location.pathname.includes('getchildrenreading') || (this.props.createdAt && new Date().toDateString() !== new Date(this.props.createdAt).toDateString() ) ? 0 : 240000
          setTimeout(() =>   this.props.openUserProfileModal()  , timer);
        }
      }

      if (languageChange === "true") {
        let loc = appLanguages.find(el => el.queryValue === locale).name;
        
        let text = <p>{t('Locale-change-notification-2', {locale: loc})} <Link href={links.editProfile()} className={`pb-app__loc`}> {t('Profile.edit-profile')} </Link></p>

        let browserLangText = <p>{t('Locale-change-notification-3', {locale: loc})} </p>

        if(translateAPILocaleList.includes(locale) && response.data){
          if (localStorage.getItem('browserLangChange')) {
            addSlimNotification({
              type: 'info',
              content: <div>{t('Locale-change-notification')} <br/> {response.data && !response.data.isLoggedIn && browserLangText }</div>
            })
            localStorage.removeItem('browserLangChange')
          }
          else {
            addSlimNotification({
              type: 'info',
              content: <div>{t('Locale-change-notification')} <br/> {response.data && response.data.isLoggedIn && text}</div>
            });
          }
          localStorage.setItem('languageChange', "false");  
        }
        else if(locale !== 'en' && response.data.isLoggedIn){
          addSlimNotification({
            type: 'info',
            content: text
          });
          localStorage.setItem('languageChange', "false");    
        }
        else if(locale !== 'en' && !response.data.isLoggedIn && localStorage.getItem('browserLangChange')) {
          addSlimNotification({
            type: 'info',
            content: browserLangText
          })
          localStorage.removeItem('browserLangChange')
        }
      }
    });

    if(process.env.REACT_APP_FEATURE_MANDATORY_LOGIN)
      this.initializePolicyManager();
    this.props.fetchSeoDataWorkflow();
  }

  componentDidUpdate(prevProps) {
    let homePagesArr = [links.home(), links.studentHome(), links.parentHome(), links.educatorHome(), links.home()+'/', links.studentHome()+'/', links.parentHome()+'/', links.educatorHome()+'/']

    let browserCheck = siteLocale === "en" && (navigator.language !== "en" || navigator.language.includes("en")) && !this.props.browserPreferences && siteLocaleLanguages.includes(navigator.language) && this.props.isLoggedIn && (window.location.pathname === links.home() || window.location.pathname === links.home() + "/" || window.location.pathname === links.studentHome() || window.location.pathname === links.parentHome() || window.location.pathname === links.educatorHome())

    if  (!isEqual(prevProps.isLoggedIn, this.props.isLoggedIn) && this.props.isLoggedIn) {
      // User logged in, load notifications
      this.props.fetchPlatformNotificationsWorkflow()
      localStorage.setItem('profileType', this.props.profileType);
      if(this.props.profile.signInCount > 1 && browserCheck){
        changeLanguage(navigator.language, navigator.language);
      }
      else if ( !isEqual(this.props.localePreferences, siteLocale) && this.props.localePreferences && (this.props.profile.signInCount > 1 || (this.props.profile.signInCount === 1 && ( window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === pageURLString.readingProgramme || window.location.pathname.replace(`/${siteLocale}`, '') === "/foundational-literacy-programme/grades" || window.location.pathname.includes("/foundational-create-classroom") || window.location.pathname.replace(`/${siteLocale}`, '') === "/stem-literacy-programme/trainingresources" || window.location.pathname.replace(`/${siteLocale}`, '') === "/foundational-literacy-programme/trainingresources" || window.location.pathname.replace(`/${siteLocale}`, '') === "/profile" || window.location.pathname.includes("/foundational-literacy-programme/resource") || window.location.pathname.replace(`/${siteLocale}`, '') === "/foundational-literacy-programme")))) {
        changeLanguage(this.props.localePreferences)
      }
    }
    if  (!isEqual(prevProps.profileType, this.props.profileType) && this.props.profileType) {
      localStorage.setItem('profileType', this.props.profileType);
      if(this.props.profile.signInCount === 1) {
        if(browserCheck) changeLanguage(navigator.language, navigator.language);
        else if(!isEqual(this.props.localePreferences, siteLocale) && this.props.localePreferences) changeLanguage(this.props.localePreferences)
      }
    }

    if  (!isEqual(prevProps.isFetchingHome, this.props.isFetchingHome) && !this.props.isFetchingHome) {
      if(this.props.profile.signInCount === 1) {
        if(browserCheck) changeLanguage(navigator.language, navigator.language);
        else if(!isEqual(this.props.localePreferences, siteLocale) && this.props.localePreferences) changeLanguage(this.props.localePreferences)
      }
      if( homePagesArr.includes(window.location.pathname) ) {
        setTimeout(() => {
          this.props.openDonateModal(); 
        }, 300000)
      }
    }

    if(!isEqual(prevProps.isFetchingMe, this.props.isFetchingMe) && !this.props.isFetchingMe) {
      if(window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === pageURLString.readingProgramme) {
        const urlParams = new URLSearchParams(window.location.search);
        const campaign = urlParams.get('campaign');
        if(!this.props.isLoggedIn) {
          if(campaign === "goa") {
            this.props.openAuthModal({
              stage: userAuthStages.otp
            });
          }
        }
      }
      if(!this.props.isLoggedIn) {
        let browserCheck = siteLocale === "en" && (navigator.language !== "en" || navigator.language.includes("en")) && !localStorage.getItem("browserLang") && siteLocaleLanguages.includes(navigator.language) &&  homePagesArr.includes(window.location.pathname)
        if(browserCheck) {
          changeLanguage(navigator.language, navigator.language);
          localStorage.setItem("browserLang", navigator.language)
          localStorage.setItem("browserLangChange", true)
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.offlineBooks, nextProps.offlineBooks) && !localStorage.getItem('updatedRPbooks')) {
      // handle existing RP books for SW-4698
      this.updateRPBooks(nextProps.offlineBooks);
    }

    if (!isEqual(this.props.isLoggedIn, nextProps.isLoggedIn) && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') !== pageURLString.readingProgramme && window.location.pathname.replace(`/${siteLocale}`, '') !== "/foundational-literacy-programme/grades" && !window.location.pathname.includes("/foundational-create-classroom") && !window.location.pathname.includes("/stem-literacy-programme/trainingresources") && window.location.pathname.replace(`/${siteLocale}`, '') !== "/profile" && !window.location.pathname.includes("/foundational-literacy-programme/resource") && !window.location.pathname.includes("/foundational-literacy-programme/trainingresources") && window.location.pathname.replace(`/${siteLocale}`, '') !== "/foundational-literacy-programme") {
      if (nextProps.profile.showUserProfiling === true  &&  nextProps.profile.signInCount !== 1) {
        let timer = window.location.pathname.includes('getchildrenreading') || (nextProps.createdAt && new Date().toDateString() !== new Date(nextProps.createdAt).toDateString())  ? 0 : 240000
        setTimeout(() =>   this.props.openUserProfileModal()  , timer);
      }
    }
    
  }

  updateRPBooks = (offlineBooks) => {
    const RPBooks = offlineBooks.books.filter(book => book.isFromReadingProgram && !book.fluencyId);
    if (RPBooks.length) {
      let RPpromises = RPBooks.map(book => this.props.updateThemeDetails(book));

      this.setState({ isUpdatingRPBooks: true });
      Promise.all(RPpromises).then(() => {
        this.setState({ isUpdatingRPBooks: false })
        localStorage.setItem('updatedRPbooks', true)
        localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
      })
    }
    else {
      localStorage.setItem('updatedRPbooks', true)
    }
  }

checkOrientation = () => {
// because fullscreen API is not supported in iPhone
    if(window.orientation !== undefined){
      let landscapeMode = Math.abs(window.orientation);
      this.setState({landscapeMode});
    }  
  }

  initializePolicyManager = () => {
    myPersistStore.initWithStorage(localStorage);
    loginPolicy.initWithLoginPolicy();
  };

  onChangeLanguage = (newLanguage) => {
    
    this.setState({ dropdownSelectedLanguage: newLanguage });
    const {
      changeLanguage,
    } = this.props;

    changeLanguage(newLanguage);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.props.onWindowSizeChange);
  }

  onReadClicked = (book, sectionClicked) => {
    const {
      fetchBookAssetsWorkflow,
      fetchNextReadBooksWorkflow,
      openGlobalBookReader,
      closeNextReadSuggestions,
      profile,
      online,
      openAuthModal,
      readSource,
      campaignSetStoryStatus,
      campaignCheckStoryStatus,
      disableNextRead,
      profileType
    } = this.props;
    if(process.env.REACT_APP_FEATURE_MANDATORY_LOGIN) {
        if (loginPolicy.shouldShowMandatoryLogin() && online) {
          openAuthModal({
            stage: userAuthStages.mandatoryLogin
          })
        } else {
          fetchBookAssetsWorkflow(book.slug)
          .then(openGlobalBookReader({book, readingListNextReadBooks: this.props.readingListNextReadBooks, readSource, regId: this.props.regId, storyId: book.id}))
          .then(() => {
            if(this.props.regId && disableNextRead){
              campaignSetStoryStatus(book.id, this.props.regId, 'started', this.props.campaignType)
              .then( response =>{ 
                if( response.ok) {
                  campaignCheckStoryStatus(this.props.regId, this.props.campaignType);
                }
              }) 
            }
          })
          .then(closeNextReadSuggestions)
          .then(() => fetchNextReadBooksWorkflow(book.slug));
        window.dataLayer.push({  
          event: gaEventActions.startReading,
          category: gaEventLabel.storyModal,
          label: gaEventLabel.nextStoryButton,
          item_type: gaEventLabel.bookLangLevel, 
          item_id: book.id, 
          item_value: `${book.language}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`, 
          user_id: profile.id, 
          user_profile: profileType
        })

        loginPolicy.storyRead(book.slug);
      }
    }
  };

  onNextReadModalCloseClicked = () => {
    const {
      profile,
      closeNextReadSuggestions,
      profileType,
    } = this.props;
  
    window.dataLayer.push({
      'event': gaEventActions.closedSelectedStories,
      'category': gaEventLabel.storyModal,
      'label': gaEventLabel.nextStorySuggestions,
      'item_type': null,
      'item_id': null,
      'item_value': null,
      'user_profile': profileType,
      'user_id': profile.id
    })
    closeNextReadSuggestions();   
  }

  render() {
    const baseClassName = 'pb-app';
    const {
      t,
      viewport,
      chromeless,
      isLoggedIn,
      profile,
      profileType,
      logoutWorkflow,
      isFetchingMe,
      isConsentGiven,
      updateConsentWorkflow,
      postEditBookWorkflow,
      blockUserWorkflow,
      blockStoryWorkflow,
      resolveSuggestionsWorkflow,
      isSubscribed,
      isFetchingSubscribe,
      subscribeWorkflow,
      fetchMeWorkflow,
      online,
      bookAssets,
      isGlobalBookReaderVisible,
      closeGlobalBookReader,
      isGlobalNextReadSuggestionsVisible,
      closeNextTranslationSuggestions,
      isGlobalNextTranslationSuggestionsVisible,
      nextTranslationBooks,
      isFetchingBookAssets,
      openNextReadSuggestions,
      isGlobalQuickViewVisible,
      currentGlobalQuickViewBook,
      closeGlobalQuickView,
      openAuthModal,
      stage,
      globalBookReaderStartPage,
      addSlimNotification,
      isOfflineBookModalVisible,
      isUserFeedbackModalVisible,
      isNotificationModalVisible,
      isSmileyRatingModalVisible,
      addSmileyRatingModal,
      isGatingFormVisible,
      showImageGatingForm,
      removeGatingForm,
      isFlaggingBook,
      isUploadingGatingForm,
      isUploadingUserProfile,
      closeNextReadSuggestions,
      postFlagBookWorkflow,
      addGatingForm,
      postSmileyRatingWorkflow,
      changeUserFeedbackModalStatusWorkflow,
      closeUserProfileModal,
      postSuggestionWorkflow,
      postGatingFormDataWorkflow,
      postUserProfileDataWorkflow,
      autoCompleteUserDataWorkflow,
      postImageGatingFormDataWorkflow,
      fetchBookWorkflow,
      removeSmileyRatingModal,
      openGlobalBookReader,
      book,
      windowDimensions,
      nextReadBooks,
      currentGlobalBookReaderBook,
      showAudioBookReader,
      showAttributionPage,
      showFlp,
      isUserBlocked,
      fetchBookAssetsWorkflow,
      isSubmittingSmileyRating,
      smileyRatingBook,
      currentGlobalBookReaderSlug,
      fetchSmileyRatingBookWorkflow,
      isFetchingSmileyRatingBook,
      fetchNextReadBooksWorkflow,
      fetchExtendedBookWorkflow,
      isFetchingNextReadBooks,
      showAudioBookReaderOnBack,
      storyfinder,
      isGlobalTranslationModalVisible,
      currentGlobalTranslationModalBook,
      closeTranslationModal,
      translateTargetLanguage,
      changeTargetLanguage,
      fetchFiltersWorkflow,
      isFetchingTranslateFilters,
      translateFilters,
      fetchCheckTranslationsWorkflow,
      fetchMobileTranslationsWorkflow,
      availableTranslations,
      isCheckingTranslations,
      openTranslateTabLink,
      isFetchingNextTranslationBooks,
      nextSuggestionsType,
      translateToLanguage,
      suggestions,
      fetchSuggestionsWorkflow,
      isFetchingSuggestions,
      isEditingBook,
      resetSuggestions,
      updatePageContent,
      userBlockedById,
      updateReviewerSuggestions,
      isListQuickViewVisible,
      currentQuickViewList,
      closeListQuickView,
      offlineBooks,
      saveOfflineWorkflow,
      unsaveOfflineWorkflow,
      addNotificationModal,
      removeNotificationModal,
      readingListNextReadBooks,
      postTranslationEditorFeedbackWorkflow,
      isSubmittingTranslationEditorFeedback,
      readingProgramBook,
      disableNextRead,
      flpBook,
      isSupplementary,
      translatePartner,
      setStoryStatusFn,
      flpSetStoryStatusFn,
      checkStoryStatus,
      storyId,
      themeNumber,
      enrollmentId,
      isAuthModalVisible,
      enablePortraitViewMessage,
      disablePortraitViewMessage,
      showPortraitMsg,
      isRpOnboardingModalVisible,
      fluencyLevel,
      readStoryStatus,
      fluencyNumber,
      themeName,
      readSource,
      hideHeaderFooter,
      mobileTranslate,
      offlineTranslateTargetLanguage,
      translateOfflineMode,
      secClicked,
      saveOfflineTranslationsWorkflow,
      unsaveOfflineTranslationsWorkflow,
      fetchOfflineTranslationsWorkflow,
      assetsForOfflineTranslate,
      isOfflineTranslatorVisible,
      closeOfflineTranslator,
      currentOfflineTranslatorBook,
      offlineTranslatorStartPage,
      currentOfflineTranslatorSlug,
      isSubmittingOfflineTranslateData,
      postOfflineTranslateDataWorkflow,
      fetchAssetsForOfflineTranslateWorkflow,
      updateOfflineTranslationsWorkflow,
      activeDropdown,
      menuSelected,
      updateActiveDropdownLink,
      updateActiveMenuSelected,
      bottomMenuSelected,
      isBottomMenuSelected,
      isRtl,
      postOfflineTranslationFeedbackWorkflow,
      isSubmittingOfflineTranslationFeedback,
      isUserProfileModalVisible,
      autoCompleteData,
      isEmailConfirmed,
      filters,
      fetchProfileWorkflow,
      fetchAutoSuggestionsWorkflow,
      updateWordSearchFrequencyWorkFlow,
      addNewSearchWordWorkFlow,
      autoSuggestions,
      searchQuery,
      isFetchingAutoSuggestions,
      enrollFlpUser,
      closeFlpEnrolModal,
      campaignCheckStoryStatus, 
      campaignSetStoryStatus,
      regId,
      campaignType,
      platformNotifications,
      markAllNotificationsAsReadWorkflow,
      markOneNotificationsAsReadWorkflow,
      fetchAllListsFiltersWorkflow,
      fetchBannerImagesWorkflow,
      setFlpProgress,
      engagementData,
      readCount,
      fetchEngagementWorkFlow,
      fetchTrendingThemesWorkflow,
      trendingThemes,
      isTrendingTheme,
      isOfflineRp,
      fetchAllReadalongFiltersWorkflow,
      raFilters,
      seoData,
      localePreferences,
      resourceDetails,
      isFromFlp,
      flpGrade,
      staticSubGcrData,
      // ptrOrgs,
      // isPTREnrolledUser
    } = this.props;
   const {landscapeMode} = this.state;
    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--fill-height`]: (!chromeless && !this.props.location.pathname.includes("search") && !this.props.location.pathname.includes("/volunteer") && !this.props.location.pathname.includes("/careers"))
    };

    const urlParams = new URLSearchParams(window.location.search);
    const locale = urlParams.get('language') || 'en';
    let messages = Object.keys(locales).includes(locale) ? locales[locale] : locales['en']

    //Add more programs if required
    let langSpecificPrograms = window.location.pathname.includes("foundational-literacy-programme") || window.location.pathname.includes("stem-literacy-programme");

    const url = window.location.host
    const subDomain = url.split('.')[0]
    
    const title = seoData && seoData.title ? seoData.title : t('global.new-site-title');
    const description = seoData && seoData.description ? seoData.description : t('global.new-site-description');

    return (
      <div className={classNames(classes)}>
        <Helmet htmlAttributes={{ lang : siteLocale}}>
          <title>{title}</title>
          <meta name="description" content={description}/>
          <link rel="canonical" href={window.location.href} />
          {appLanguages.map(el => <link rel="alternate" href={window.location.href.replace(`/${siteLocale}`, `/${el.queryValue}`)} hreflang={el.queryValue}></link>)}
          <link rel="alternate" href={window.location.href.replace(`/${siteLocale}`, `/en`)} hreflang={'x-default'}></link>)
        </Helmet>
        {<BackToTop 
          viewport={viewport}
          isRtl={isRtl}
          isLoggedIn={isLoggedIn}
          subDomain={subDomain}
          t={t}
          isFetchingMe={isFetchingMe}
          isConsentGiven={isConsentGiven}
        />}
        {
          chromeless || hideHeaderFooter
          ?
          null
          :
          <SiteHeader
            viewport={viewport}
            isLoggedIn={isLoggedIn}
            user={profile}
            logout={logoutWorkflow}
            isFetchingMe={isFetchingMe}
            offline={!online}
            openAuthModal={() => openAuthModal()}
            addSlimNotification={addSlimNotification}
            isRtl={isRtl}
            isUpdatingRPBooks={this.state.isUpdatingRPBooks}
            activeDropdown={activeDropdown}
            menuSelected={menuSelected}
            bottomMenuSelected={bottomMenuSelected}
            isBottomMenuSelected={isBottomMenuSelected}
            updateActiveDropdownLink={updateActiveDropdownLink}
            updateActiveMenuSelected={updateActiveMenuSelected}
            changeLanguage={this.onChangeLanguage}
            filters={filters}
            fetchAutoSuggestionsWorkflow={fetchAutoSuggestionsWorkflow}
            updateWordSearchFrequencyWorkFlow={updateWordSearchFrequencyWorkFlow}
            addNewSearchWordWorkFlow={addNewSearchWordWorkFlow}
            autoSuggestions={autoSuggestions}
            searchQuery={searchQuery}
            isFetchingAutoSuggestions={isFetchingAutoSuggestions}
            platformNotifications={platformNotifications}
            markAllNotificationsAsReadWorkflow={markAllNotificationsAsReadWorkflow}
            markOneNotificationsAsReadWorkflow={markOneNotificationsAsReadWorkflow}
            fetchAllListsFiltersWorkflow={fetchAllListsFiltersWorkflow}
            fetchTrendingThemesWorkflow={fetchTrendingThemesWorkflow}
            trendingThemes={trendingThemes}
            isTrendingTheme={isTrendingTheme}
            raFilters={raFilters}
            fetchAllReadalongFiltersWorkflow={fetchAllReadalongFiltersWorkflow}
            localePreferences={localePreferences}
            staticSubGcrData={staticSubGcrData}
          />
        }
        {chromeless ? null : <Suspense fallback={null}><SlimNotificationContainer isRtl={isRtl}/></Suspense> }
        
        <div className={`${baseClassName}__content`}>
          <ToggleSidebar 
            isLoggedIn={isLoggedIn}
            user={profile}
            t={t}
            viewport={viewport}
            children={this.props.children}
            openAuthModal={() => openAuthModal()}
            parentClassName={baseClassName}
            updateActiveDropdownLink={updateActiveDropdownLink}
            activeDropdown={activeDropdown}
            isRtl={isRtl}
            profileType={profileType}
            location={this.props.location}
            engagementData={engagementData}
            readCount={readCount}
            fetchEngagementWorkFlow={fetchEngagementWorkFlow}
            isStudentProfile={window.location.pathname.replace(`/${siteLocale}`, '') === '/student' || 
            ( profileType === mapUserGatewayProfileType[userProfileType.STUDENT] && 
              ( studentMenuWhitelist.includes(window.location.pathname.replace(`/${siteLocale}`, '')) || window.location.pathname.replace(`/${siteLocale}`, '').startsWith('/reading-programme'))
            )}
            filters={filters}
            fetchAllListsFiltersWorkflow={fetchAllListsFiltersWorkflow}
            raFilters={raFilters}
            fetchAllReadalongFiltersWorkflow={fetchAllReadalongFiltersWorkflow}
          />
        </div>

        <SiteFooterNotice 
          isRtl={isRtl}
          isFetchingMe={isFetchingMe}
          isLoggedIn={isLoggedIn}
          isConsentGiven={isConsentGiven}
          updateConsent={updateConsentWorkflow}
        />

        {
          chromeless || hideHeaderFooter
          ?
          null
          :
          <RenderOnViewportEntry>
            <SiteFooter
              isLoggedIn={isLoggedIn}
              isSubscribed={isSubscribed}
              isFetchingSubscribe={isFetchingSubscribe}
              subscribe={subscribeWorkflow}
              shouldShowLanguageSelector={true}
              offline={!online}
              changeLanguage={this.onChangeLanguage}
              viewport={viewport}
              profile={profile}
              isRtl={isRtl}
            />
          </RenderOnViewportEntry>
        }
        {
          isGlobalNextTranslationSuggestionsVisible && !chromeless
            ?
            <NextTranslationModal
              onCloseClicked={() => closeNextTranslationSuggestions()} nextTranslationBooks={nextTranslationBooks}
              viewport={viewport}
              translateToLanguage={translateToLanguage}
              nextSuggestionsType={nextSuggestionsType}
              isFetchingNextTranslationBooks={isFetchingNextTranslationBooks}
              translationEditorFeedbackPresent={!isLoggedIn || profile.translationEditorFeedbackPresent}
              postTranslationEditorFeedbackWorkflow={postTranslationEditorFeedbackWorkflow}
              isSubmittingTranslationEditorFeedback={isSubmittingTranslationEditorFeedback}
              isFetchingMe={isFetchingMe}
              isRtl={isRtl}
              offlineTranslationEditorFeedbackPresent={!isLoggedIn || profile.offlineTranslationEditorFeedbackPresent}
              postOfflineTranslationFeedbackWorkflow={postOfflineTranslationFeedbackWorkflow}
              addSlimNotification={addSlimNotification}
              isSubmittingOfflineTranslationFeedback={isSubmittingOfflineTranslationFeedback}
              />
            :
            null
        }
        {
          isGlobalBookReaderVisible
          ?
          <Suspense fallback={null}>
            <BookReaderModal
              showAttributionPage={showAttributionPage}
              isUserBlocked={isUserBlocked}
              startPage={globalBookReaderStartPage}
              closeGlobalBookReader={closeGlobalBookReader}
              viewport={viewport}
              isLoggedIn={isLoggedIn}
              assets={bookAssets}
              offline={!online}
              userEmail={profile.email}
              userName={profile.name}
              userId={profile.id}
              userRoles={profile.roles}
              book={currentGlobalBookReaderBook}
              windowDimensions={windowDimensions}
              openNextReadSuggestions={openNextReadSuggestions}
              showAudioBookReader={showAudioBookReader}
              addSmileyRatingModal={addSmileyRatingModal}
              slug={currentGlobalBookReaderSlug}
              fetchSmileyRatingBook={fetchSmileyRatingBookWorkflow}
              changeUserFeedbackModalStatusWorkflow={changeUserFeedbackModalStatusWorkflow}
              addSlimNotification={addSlimNotification}
              postSuggestionWorkflow={postSuggestionWorkflow}
              fetchSuggestionsWorkflow={fetchSuggestionsWorkflow}
              resetSuggestions={resetSuggestions}
              updatePageContent={updatePageContent}
              userBlockedById={userBlockedById}
              updateReviewerSuggestions={updateReviewerSuggestions}
              suggestions={suggestions}
              isFetchingSuggestions={isFetchingSuggestions}
              isEditingBook={isEditingBook}
              onEditBookDetailClicked={postEditBookWorkflow}
              blockUserWorkflow={blockUserWorkflow}
              blockStoryWorkflow={blockStoryWorkflow}
              resolveSuggestionsWorkflow={resolveSuggestionsWorkflow}
              readingProgramBook={readingProgramBook}
              disableNextRead={disableNextRead}
              translatePartner={ translatePartner}
              setStoryStatusFn={setStoryStatusFn}
              flpSetStoryStatusFn={flpSetStoryStatusFn}
              checkStoryStatus={checkStoryStatus}
              storyId={storyId}
              themeNumber={themeNumber}
              enrollmentId={enrollmentId}
              openAuthModal={openAuthModal}
              disablePortraitViewMessage={disablePortraitViewMessage}
              enablePortraitViewMessage={enablePortraitViewMessage}
              readStoryStatus={readStoryStatus}
              fluencyNumber={fluencyNumber}
              themeName={themeName}
              readSource={readSource}
              mobileTranslate={mobileTranslate}
              isEmailConfirmed={isEmailConfirmed}
              isRtl={isRtl}
              flpBook={flpBook}
              isSupplementary={isSupplementary}
              campaignSetStoryStatus={campaignSetStoryStatus}
              campaignCheckStoryStatus={campaignCheckStoryStatus}
              regId={regId}
              campaignType={campaignType}
              setFlpProgress={setFlpProgress}
              userType={profileType}
              profileType={window.location.pathname.includes('/student') ? mapUserGatewayProfileType[userProfileType.STUDENT]: (window.location.pathname.includes('/educator') ? mapUserGatewayProfileType[userProfileType.TEACHER] : (window.location.pathname.includes('/parent') ? mapUserGatewayProfileType[userProfileType.PARENT] : ''))}
              isOfflineRp={isOfflineRp}
              showPortraitMsg={showPortraitMsg}
            />
          </Suspense>
          :
          null
        }
        {
          isGlobalNextReadSuggestionsVisible && online
          ?
          <Suspense fallback={null}>
            <NextReadModal
              onCloseClicked={this.onNextReadModalCloseClicked}
              onReadClicked={this.onReadClicked}
              nextReadBooks={nextReadBooks}
              currentGlobalBookReaderSlug={currentGlobalBookReaderSlug}
              readingListNextReadBooks={readingListNextReadBooks}
              isFetchingBookAssets={isFetchingBookAssets}
              viewport={viewport}
              userEmail={profile.email}
              isRtl={isRtl}
              storyFinder={readSource === sectionClicked.storyfinderRead}
              userType={profileType}
              userId={profile.id}
            />
          </Suspense>
          :
          null
        }
        {
          isGlobalQuickViewVisible
          ?
          <Suspense fallback={null}>
            {
              langSpecificPrograms ?
              <I18n locale={locale} messages={messages}>
                <QuickViewModal
                  viewport={viewport}
                  book={currentGlobalQuickViewBook}
                  onCloseClicked={() => closeGlobalQuickView()}
                  online={online}
                  flpBook={flpBook}
                  isSupplementary={isSupplementary}
                  openAuthModal={openAuthModal}
                  isRtl={currentGlobalQuickViewBook.language && rtlLanguages.includes(currentGlobalQuickViewBook.language)}
                />
              </I18n>
              :
              <QuickViewModal
                viewport={viewport}
                book={currentGlobalQuickViewBook}
                onCloseClicked={() => closeGlobalQuickView()}
                online={online}
                openAuthModal={openAuthModal}
                isRtl={currentGlobalQuickViewBook.language && rtlLanguages.includes(currentGlobalQuickViewBook.language)}
              />
            }
          </Suspense>
          :
          null
        }
        {
          isGatingFormVisible
            ?
            <Suspense fallback={null}>
              <GatingForm
                isVisible={isGatingFormVisible}
                viewport={viewport}
                book={book}
                showImageGatingForm={showImageGatingForm}
                postGatingFormDataWorkflow={postGatingFormDataWorkflow}
                organisation={profile.orgName}
                isUploadingGatingForm={isUploadingGatingForm}
                removeGatingForm={removeGatingForm}
                addSlimNotification={addSlimNotification}
                postImageGatingFormDataWorkflow={postImageGatingFormDataWorkflow}
                imageId={this.props.gatingFormImageId}
                user={profile}
                showStoryGatingForm={this.props.showStoryGatingForm}
                showStoryGatingFormPdf={this.props.showStoryGatingFormPdf}
                format={this.props.format}
                storyId={this.props.gatingFormStoryId}
                downloadLink={this.props.downloadLink}
              />
            </Suspense>
            :
            null
        }
        {
          isUserProfileModalVisible && online
            ?
            <Suspense fallback={null}>
              <UserProfileModal
                isVisible={isUserProfileModalVisible}
                viewport={viewport}
                closeUserProfileModal={closeUserProfileModal}
                postUserProfileDataWorkflow={postUserProfileDataWorkflow}
                autoCompleteUserDataWorkflow={autoCompleteUserDataWorkflow}
                autoCompleteData={autoCompleteData}
                isUploadingUserProfile={isUploadingUserProfile}
                addSlimNotification={addSlimNotification}
                userId={profile.id}
                fetchMeWorkflow={fetchMeWorkflow}
                fetchProfileWorkflow={fetchProfileWorkflow}
                isRtl={isRtl}
                enrollFlpUser={enrollFlpUser}
                closeFlpEnrolModal={closeFlpEnrolModal}
                showFlp={showFlp}
                fetchBannerImagesWorkflow={fetchBannerImagesWorkflow}
                resourceDetails={resourceDetails}
                isFromFlp={isFromFlp}
                flpGrade={flpGrade}
              />
            </Suspense>
            :
            null
        }
        {
          isListQuickViewVisible
          ?
          <Suspense fallback={null}>
            <ListQuickViewModal
              viewport={viewport}
              list={currentQuickViewList}
              onCloseClicked={() => closeListQuickView()}
              offlineBooks={offlineBooks}
              saveOfflineWorkflow={saveOfflineWorkflow}
              unsaveOfflineWorkflow={unsaveOfflineWorkflow}
              isAvailableOffline={isAvailableOffline}
              isLoggedIn={isLoggedIn}
              addNotificationModal={addNotificationModal}
              removeNotificationModal={removeNotificationModal}
              openAuthModal={() => openAuthModal()}
              addSlimNotification={addSlimNotification}
              windowDimensions={windowDimensions}
              addGatingForm={addGatingForm}
              fetchMeWorkflow={fetchMeWorkflow}
              userId={profile.id}
              profile={profile}
              downloadLimitReached={profile.downloadLimitReached}
              isRtl={currentQuickViewList.languages && currentQuickViewList.languages.every(lang => rtlLanguages.includes(lang))}
            />
          </Suspense>
          :
          null
        }
        {
          isAuthModalVisible
          ?
          <Suspense fallback={null}>
            <AuthModalContainer stage={stage} isRtl={isRtl} userId={profile.id}/>
          </Suspense>
          :
          null
        }
        {
          isRpOnboardingModalVisible
          ?
          <Suspense fallback={null}>
            <RpOnboardingModalContainer fluencyLevel={fluencyLevel}/>
          </Suspense>
          :
          null
        }
        {
          isOfflineBookModalVisible
          ?
          <OfflineBookModal />
          :
          null
        }

        {
          isUserFeedbackModalVisible
          ?
          <Suspense fallback={null}>
            <UserFeedbackModal />
          </Suspense>
          :
          null
        }

        {
          isNotificationModalVisible
          ?
          <Suspense fallback={null}>
            {
              langSpecificPrograms ?
              <I18n locale={locale} messages={messages}>
                <NotificationModal isRtl={isRtlLanguage(locale)}/>
              </I18n>
              :
              <NotificationModal isRtl={isRtl}/>
            }
          </Suspense>
          :
          null
        }

        {
          isSmileyRatingModalVisible
          ?
          <Suspense fallback={null}>
            <SmileyRatingModal
              isVisible={isSmileyRatingModalVisible}
              slug={currentGlobalBookReaderSlug}
              currentBookSlug={book ? book.slug : null}
              isFetchingNextReadBooks={isFetchingNextReadBooks}
              book={smileyRatingBook}
              isLoggedIn={isLoggedIn}
              isFetchingSmileyRatingBook={isFetchingSmileyRatingBook}
              isFlaggingBook={isFlaggingBook}
              viewport={viewport}
              userRoles={profile.roles}
              lastStoryPage={smileyRatingBook.lastPagePosition}
              openGlobalBookReader={openGlobalBookReader}
              openNextReadSuggestions={openNextReadSuggestions}
              closeNextReadSuggestions={closeNextReadSuggestions}
              postFlagBookWorkflow={postFlagBookWorkflow}
              postSmileyRatingWorkflow={postSmileyRatingWorkflow}
              fetchBookWorkflow={fetchBookWorkflow}
              removeSmileyRatingModal={removeSmileyRatingModal}
              userEmail={profile.email}
              userId={profile.id}
              fetchBookAssetsWorkflow={fetchBookAssetsWorkflow}
              isSubmittingSmileyRating={isSubmittingSmileyRating}
              fetchNextReadBooksWorkflow={fetchNextReadBooksWorkflow}
              showAudioBookReaderOnBack={showAudioBookReaderOnBack}
              storyfinder={storyfinder}
              isRtl={isRtl}
              isEmailConfirmed={isEmailConfirmed}
              fetchExtendedBookWorkflow={fetchExtendedBookWorkflow}
              profileType={window.location.pathname.includes('/student') ? mapUserGatewayProfileType[userProfileType.STUDENT]: (window.location.pathname.includes('/educator') ? mapUserGatewayProfileType[userProfileType.TEACHER] : (window.location.pathname.includes('/parent') ? mapUserGatewayProfileType[userProfileType.PARENT] : ''))}
              userType={profileType}
              readSource={readSource}
              isFetchingBookAssets={isFetchingBookAssets}
              />
          </Suspense>
          :
          null
        }

        {
          isGlobalTranslationModalVisible && !chromeless
          ?
          <Suspense fallback={null}>
            <TranslationModal
              isVisible={isGlobalTranslationModalVisible}
              book={currentGlobalTranslationModalBook}
              closeTranslationModal={closeTranslationModal}
              translateTargetLanguage={translateTargetLanguage}
              viewport={viewport}
              changeTargetLanguage={changeTargetLanguage}
              fetchFiltersWorkflow={fetchFiltersWorkflow}
              isFetchingTranslateFilters={isFetchingTranslateFilters}
              translateFilters={translateFilters}
              addSlimNotification={addSlimNotification}
              fetchCheckTranslationsWorkflow={fetchCheckTranslationsWorkflow}
              availableTranslations={availableTranslations}
              isCheckingTranslations={isCheckingTranslations}
              openTranslateTabLink={openTranslateTabLink}
              userEmail={profile.email}
              userId={profile.id}
              isRtl={isRtl}
              translateOfflineMode={translateOfflineMode}
              secClicked={secClicked}
              windowDimensions={windowDimensions}
              saveOfflineWorkflow={saveOfflineWorkflow}
              fetchAssetsForOfflineTranslateWorkflow={fetchAssetsForOfflineTranslateWorkflow}
              saveOfflineTranslationsWorkflow={saveOfflineTranslationsWorkflow}
              offlineTranslateTargetLanguage = {offlineTranslateTargetLanguage || translateTargetLanguage}
              fetchMobileTranslationsWorkflow={fetchMobileTranslationsWorkflow}
              userType={profileType}
              />
          </Suspense>
          :
          null
        }
        {
          (landscapeMode && showPortraitMsg)
          ?
          <Suspense fallback={null}><PortraitViewMessage isRtl={isRtl}/></Suspense>
          :
          null
        }

        {
          isOfflineTranslatorVisible
          ?
          <OfflineTranslateModal
            showAttributionPage={showAttributionPage}
            startPage={offlineTranslatorStartPage}
            closeOfflineTranslator={closeOfflineTranslator}
            viewport={viewport}
            isLoggedIn={isLoggedIn}
            assets={assetsForOfflineTranslate}
            offline={!online}
            userId={profile.id}
            book={currentOfflineTranslatorBook}
            windowDimensions={windowDimensions}
            slug={currentOfflineTranslatorSlug}
            saveOfflineTranslationsWorkflow={saveOfflineTranslationsWorkflow}
            unsaveOfflineTranslationsWorkflow={unsaveOfflineTranslationsWorkflow}
            postOfflineTranslateDataWorkflow={postOfflineTranslateDataWorkflow}
            fetchOfflineTranslationsWorkflow={fetchOfflineTranslationsWorkflow}
            isSubmittingOfflineTranslateData={isSubmittingOfflineTranslateData}
            addSlimNotification={addSlimNotification}
            offlineBooks={offlineBooks}
            updateOfflineTranslationsWorkflow={updateOfflineTranslationsWorkflow}
            userEmail={profile.email}
            isRtl={isRtl}
          />
          :
          null
        }

        {
          online && this.props.isDonateModalVisible && profileType !== mapUserGatewayProfileType[userProfileType.STUDENT]
            ?
            <Suspense fallback={null}>
              {/* <DonateModal
                onClose={this.props.closeDonateModal}
                user={profile}
                viewport={viewport}
                updateDonatePopupStatusWorkFlow={this.props.updateDonatePopupStatusWorkFlow}
                isRtl={isRtl}
              /> */}
              <DonateSeason
                onClose={this.props.closeDonateModal}
                user={profile}
                viewport={viewport}
                modalType={"campaign_gcr"}
                localePreferences={localePreferences}
                siteLocale={siteLocale}
                // isRtl={isRtl}
              />
            </Suspense>
            :
            null
        }
      </div>
    );
  }
}

AppContainer.propTypes = {
  chromeless: PropTypes.bool,
};

export default withRouter(AppContainer);



// WEBPACK FOOTER //
// ./src/components/AppContainer/AppContainer.jsx